import { apiClient } from '../apiClient';

const getTokenHeaders = (extraHeaders = {}) => {
  const token = localStorage.getItem('token');
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extraHeaders,
  };
};

export const getDeviceVersionPolicyConfig = async () => {
  try {
    const response = await apiClient.get('/pmiDevices/settings/version-management', {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching device version policy config:', error);
    throw error;
  }
};

export const getPmiRuntimeControlsConfig = async () => {
  try {
    const response = await apiClient.get('/pmiDevices/settings/runtime-controls', {
      params: {
        _ts: Date.now(),
      },
      headers: getTokenHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      }),
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching PMI runtime controls config:', error);
    throw error;
  }
};

export const updatePmiRuntimeControlsConfig = async (payload = {}) => {
  try {
    const response = await apiClient.put('/pmiDevices/settings/runtime-controls', payload, {
      headers: getTokenHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      }),
    });
    return response.data;
  } catch (error) {
    console.error('Error updating PMI runtime controls config:', error);
    throw error;
  }
};

export const updateDeviceVersionPolicyConfig = async (payload = {}) => {
  try {
    const response = await apiClient.put('/pmiDevices/settings/version-management', payload, {
      headers: getTokenHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error updating device version policy config:', error);
    throw error;
  }
};
